import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { RbacRoleEntity } from './rbac-role.entity';
import { ViewLayoutConfigurationEntity } from './view-layout-configuration.entity';

@Index('idx_view_layout_role_unique', ['fkViewLayoutId', 'fkRbacRoleId'], {
	unique: true,
})
@Index('idx_view_layout_role_layout', ['fkViewLayoutId'])
@Index('idx_view_layout_role_role', ['fkRbacRoleId'])
@Entity('view_layout_role')
export class ViewLayoutRoleEntity extends BaseEntity {
	@Column('int', { name: '_fk_view_layout__id', unsigned: true })
	public fkViewLayoutId!: number;

	@Column('int', { name: '_fk_rbac_role__id', unsigned: true })
	public fkRbacRoleId!: number;

	@ManyToOne(
		() => ViewLayoutConfigurationEntity,
		(layout) => layout.sharedRoles,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk_view_layout__id', referencedColumnName: 'id' }])
	public fkViewLayout!: ViewLayoutConfigurationEntity;

	@ManyToOne(() => RbacRoleEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_rbac_role__id', referencedColumnName: 'id' }])
	public fkRbacRole!: RbacRoleEntity;
}
